export default {
  name: 'LayoutBasic',
  props: {
    width: {
      default: 'is-two-thirds-desktop',
      type: String
    }
  },
  data () {
    return {}
  }
}
